import UpdateQueueTaskPriorityRequestItem from '../../../../../projects/task/i-service/models/type-priority/UpdateQueueTaskPriorityRequestItem';

/**
 * * Модель запроса на обновление приоритетов очереди задач
 */
export default class UpdateQueueTaskPriorityRequest  {
	/**
	 * * Номер очереди задач
	 */
	QueueTaskId!: string;
	/**
	 * * Список приоритетов
	 */
	Priorities!: Array<UpdateQueueTaskPriorityRequestItem>;
	constructor(obj?: Partial<UpdateQueueTaskPriorityRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
